import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Skeleton } from '@mui/material';
import { Decimal, NoValue } from '~/modules/common/components';
import { PERIOD_SCALE_ENUM } from '~/modules/common/charts/timeline';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 0,
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: theme.spacing(4.5),
    padding: theme.spacing(0, 1)
  },
  hours: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.caption.fontSize
  }
}));

const getPrecision = scale => {
  switch (scale) {
    case PERIOD_SCALE_ENUM.DAYS:
      return 0;
    case PERIOD_SCALE_ENUM.WEEKS:
      return 1;
    default:
      return 2;
  }
};

export const PeriodTotalBlock = ({
  totalHours,
  width,
  scale,
  loading = false,
  qeIdTag
}) => {
  const classes = useStyles();

  const widthStyle = useMemo(() => ({ width, minWidth: width }), [width]);

  if (loading) {
    return (
      <div className={classes.root} style={widthStyle}>
        <Skeleton variant="text" width="100%" height={16} />
      </div>
    );
  }

  return (
    <div className={classes.root} style={widthStyle} data-qe-id={qeIdTag}>
      {totalHours ? (
        <Decimal
          precision={getPrecision(scale)}
          value={totalHours}
          suffix="h"
          className={classes.hours}
          dataQeId={qeIdTag ? `${qeIdTag}_Hours` : undefined}
        />
      ) : (
        <NoValue />
      )}
    </div>
  );
};

PeriodTotalBlock.propTypes = {
  totalHours: PropTypes.number,
  width: PropTypes.number.isRequired,
  scale: PropTypes.string,
  loading: PropTypes.bool,
  qeIdTag: PropTypes.string
};

export default PeriodTotalBlock;
